import { createFileRoute } from '@tanstack/react-router'
import { Skeleton } from 'antd'
import { AssetOverview } from 'pages/assetDatabase/assetOverview/AssetOverview'
import { AssetViews } from 'pages/assetDatabase/assetOverview/header/AssetHeader'
import React from 'react'
import { z } from 'zod'

const assetDetailsSearchSchema = z.object({
  view: z
    .enum(Object.values(AssetViews) as [string, ...string[]])
    .default(AssetViews.DETAILS),
  // Table state parameters
  sortBy: z.string().optional(),
  sortDesc: z.boolean().optional(),
  filters: z
    .record(
      z.string(),
      z.union([
        z.string(),
        z.number(),
        z.boolean(),
        z.array(z.string()),
        z.tuple([z.string().nullable(), z.string().nullable()]),
      ])
    )
    .optional(),
})

export const Route = createFileRoute('/assets/$siteID/$unitID')({
  component: RouteComponent,
  pendingComponent: PendingComponent,
  validateSearch: assetDetailsSearchSchema,
  staticData: {
    title: 'Asset Details',
  },
})

// Show skeleton immediately while route is loading/navigating
function PendingComponent() {
  return <Skeleton active paragraph={{ rows: 8 }} style={{ margin: '2rem' }} />
}

function RouteComponent() {
  return <AssetOverview />
}
